var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plugin-home-features"},[_c('div',{staticClass:"plugin-home-features__list"},_vm._l((_vm.products),function(product,i){return _c('div',{key:i,staticClass:"plugin-home-features__list-item"},[_c('common-card-product',{attrs:{"product":product,"ecommerce-list-data":{
                    listId: 'special_' + (_vm.listId || 'plugin_home_features'),
                    listTitle: 'Special ' + (_vm.listTitle || 'Выборка товаров'),
                    index: i,
                }}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }